export default {
    buscando: false,
    items: [],
    formularioDinamico: null,
    expressoesBooleanas: []
}